module.exports = __webpack_public_path__ + "img/sms.5e2a38ae.svg";